import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { formatMoneda, formatoMonto, validaMonto, validaSoloNumero, seleccionarCampo } from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';
import CatalogoOrdenesdeCompraDevolver from '../../catalogos/catalogoOrdenesdeCompraDevolver';
import CatalogoTipoRetencion from '../../catalogos/catalogoRetenciones';

export const ModalAgregarISLR = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const anioefis = JSON.parse(localStorage.getItem('efiscalanio'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [habiBase, setHabiBase] = useState(true);
    const [habiAlicuo, setHabiAlicuo] = useState(true);
    const [habiRete, setHabiRete] = useState(true);
    const [habiFecha, setHabiFecha] = useState(true);
    const [visibleDat, setVisibleDat] = useState('visible');
    const [factor, setFactor] = useState(0.00);
    const [sustraendo, setSustraendo] = useState(0.00);
    const [operacion, setOperacion] = useState(0);
    const [mostrar4, setMostrar4] = useState(false);
    const [tipoRetencion, setTipoRetencion] = useState(0);
    const [tipoUnidad, setTipoUnidad] = useState(0);
    const [valorUt, setValorUt] = useState(0.00);
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [otroPorce, setOtroPorce] = useState(0.00);
    const [lblAlicuota, setLblAlicuota] = useState('Alicuota:');
    const [lblTotRete, setLblTotRete] = useState('Total Retención:');
    const [deduccion, setDeduccion] = useState(0);
    const [sumaRete, setSumaRete] = useState(0.00);
    const [rete_porciento, setRete_Porciento] = useState(0.00);
    const [datos, setDatos] = useState();
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtIdRetencion = useRef();
    const txtDescriret = useRef();
    const txtFechaRet = useRef();
    const txtBaseImpo = useRef();
    const txtPorceIva = useRef();
    const txtMontoIva = useRef();
    const txtMontoCompro = useRef();
    const txtAlicuota = useRef();
    const txtTotalRete = useRef();

    const txtUbi = useRef();

    const txtTipo = useRef();
    const txtMotivo = useRef();
    const txtIdordenpago = useRef();


    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        setActivate(false);
        setActivo(true);
        setHabiAlicuo(true);
        setHabiBase(true);
        setHabiFecha(true);
        setVisibleDat('visible');
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onDatos(datos);
        props.onHideCancela();
        blanquear();
    }

    const catalogoClass = (e) => {
        e.preventDefault();
        setMostrar4(true);
    };

    const handleInputNumChange = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                seleccionarRetencion(event.target.value);
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const handleAceptaRetenciones = (idretencion, descripcion) => {
        setMostrar4(false);
        if (props.operacion === 1) {
            for (let i = 0; i < props.retenciones.length; i++) {
                if (idretencion === props.idret[i].idretencion) {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Esta Retención ya fue Seleccionada !', icono: 'informacion' });
                    return;
                }
            }
            txtIdRetencion.current.value = idretencion;
            setActivo(false);
            seleccionarRetencion(idretencion);

        }

    }

    const handleCancelaras = () => {
        setMostrar4(false);
    }

    const seleccionarRetencion = (id) => {

        let campos = '*';
        let nomtab = 'tiporetencion';
        let nomid = 'idtiporetencion';

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

        setActivate(true);

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status === 200) {
                if (parseInt(response.data.idtiporetencion) > 0) {
                    if (props.operacion === 1) {
                        for (let i = 0; i < props.retenciones.length; i++) {
                            if (props.retenciones[i].idtiporetencion === txtIdRetencion.current.value) {
                                setActivate(false);
                                txtIdRetencion.current.value = '';
                                txtIdRetencion.current.focus();
                                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El TIPO DE RETENCION YA EXISTE', icono: 'informacion' });
                                return;
                            }
                        }
                        setHabiFecha(false);
                        txtFechaRet.current.value = moment.utc(fechaSistema).format('YYYY-MM-DD');
                    }

                    setTipoRetencion(response.data.tipo);
                    setFactor(response.data.deducible)
                    if (response.data.tipo === 0) {
                        txtAlicuota.current.value = '75,00';
                    } else if (response.data.tipo === 1) {
                        /*let n = response.data.deducible;
                        txtDeducible.current.value = n !== null ? formatMoneda(n.toString().replace(',', '').replace('.', ','), ',', '.', 2) : '0,00';
                        txtAlicuota.current.value = formatMoneda(props.montoislr.toString().replace(',', '').replace('.', ','), ',', '.', 2);*/
                    } else {
                        //txtAlicuota.current.value = '0,00';
                    }
                    txtAlicuota.current.value = '0,00';
                    setOtroPorce(response.data.otro);
                    txtDescriret.current.value = response.data.descripcion.trim();
                    setTipoUnidad(parseInt(response.data.unidad));
                    setHabiBase(false);
                    if (response.data.unidad === 0) {
                        setLblTotRete('Total Retención:');
                        setVisibleDat('visible');
                        setHabiAlicuo(false);
                        setLblAlicuota('Por Ciento (%):');
                        setHabiRete(true);
                    } else if (response.data.unidad === 1) {
                        setLblTotRete('Total Retención:');
                        setVisibleDat('visible');
                        setHabiAlicuo(false);
                        setLblAlicuota(' Por Mil (‰):');
                        setHabiRete(true);
                    } else if (response.data.unidad === 2) {
                        setLblTotRete('Total Retención:');
                        setVisibleDat('visible');
                        setHabiAlicuo(false);
                        setLblAlicuota('Unid Tributaria:');
                        setHabiRete(true);
                    } else if (response.data.unidad === 3) {
                        setLblTotRete('Monto a Retener:');
                        setVisibleDat('hidden');
                        setHabiAlicuo(true);
                        setHabiRete(false);
                    } else if (response.data.unidad === 4) {
                        setLblTotRete('Total Retención:');
                        setVisibleDat('visible');
                        setHabiAlicuo(false);
                        setLblAlicuota(' X ' + parseInt(otroPorce) + ' (‰):');
                        setHabiRete(true);
                    }
                    if (props.operacion === 2) {
                        setHabiFecha(false);
                        txtAlicuota.current.value = formatMoneda(props.retencionsel.alicuota.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                        txtTotalRete.current.value = formatMoneda(props.retencionsel.totalrete.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                        //txtFechaRet.current.value = moment.utc(props.retencionsel.fecha).format('YYYY-MM-DD');
                    }
                    seleccionarValorUnidad();
                    setActivo(false);
                    txtFechaRet.current.focus();
                } else {
                    txtIdRetencion.current.value = '';
                    txtIdRetencion.current.focus();
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Retención no existe.', icono: 'informacion' });
                }

            }

            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })

    }

    const calcular = () => {
        let alicuota = parseFloat(txtAlicuota.current.value.trim().replace(/\./g, "").replace(',', '.'));

        if (alicuota > 0.00) {

            let sustrae = alicuota / 100 * parseFloat(valorUt.toString()) * factor;
            let baseImpo = parseFloat(txtBaseImpo.current.value.trim().replace(/\./g, "").replace('.', '').replace(',', '.'));
            let tope = parseFloat(valorUt.toString()) * factor;
            let retencion_por_ciento = parseFloat(baseImpo * alicuota / 100);
            retencion_por_ciento = Math.round(parseFloat(retencion_por_ciento) * Math.pow(10, 2)) / Math.pow(10, 2);
            setRete_Porciento(retencion_por_ciento);
            if (props.natural) {

                if (baseImpo >= tope) {
                    txtTotalRete.current.value = formatMoneda((retencion_por_ciento - sustrae).toString().replace(',', '').replace('.', ','), ',', '.', 2);

                } else {
                    txtTotalRete.current.value = '0,00';
                    sustrae = 0.00;
                }

            } else {
                txtTotalRete.current.value = formatMoneda((retencion_por_ciento).toString().replace(',', '').replace('.', ','), ',', '.', 2);
                sustrae = 0.00;
            }
            setSustraendo(sustrae);
        }

    }

    const seleccionarValorUnidad = () => {
        let campos = '*';
        let nomtab = 'unidadtributaria';
        let nomid = 'anio';
        let nanio = txtFechaRet.current.value !== '' ? new Date(txtFechaRet.current.value.replace("-',',")).getFullYear() : 2010;
        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${nanio}&nomtab=${nomtab}&nomid=${nomid}`;

        setActivate(true);

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status === 200) {
                if (parseInt(response.data.anio) > 0) {
                    setValorUt(response.data.valor);
                } else {
                    setValorUt(0.00);
                }

            }

            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })
    }

    const handleRetenciones = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                seleccionarRetencion(event.target.value);
            }
        }
    };

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        let sinpuntototaret = txtTotalRete.current.value.trim().replace(/\./g, "");
        let sincomatototalret = sinpuntototaret.replace(',', '.');
        let sinpuntotot = txtMontoCompro.current.value.trim().replace(/\./g, "");
        let sincomatotot = sinpuntotot.replace(',', '.');

        if (txtIdRetencion.current.value.trim() === '' || txtDescriret.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir una Retención', icono: 'informacion' });
            sigue = false;
            txtIdRetencion.current.focus();
        } else if (txtFechaRet.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La fecha de la retención no es valida', icono: 'informacion' });
            sigue = false;
            txtFechaRet.current.focus();
        } else if (new Date(txtFechaRet.current.value).getFullYear() !== anioefis) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El año no debe ser diferente al año del Ejercicio Fiscal actual', icono: 'informacion' });
            sigue = false;
            txtFechaRet.current.focus();
        } else if (txtAlicuota.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto no debe ser Vacio', icono: 'informacion' });
            sigue = false;
            txtAlicuota.current.focus();
        } else if (txtTotalRete.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto no debe ser Vacio', icono: 'informacion' });
            sigue = false;
            txtAlicuota.current.focus();
        } else if (parseFloat(sincomatototalret) > parseFloat(sincomatotot)) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto Retenido no de debe ser Mayor que el Total de la Orden', icono: 'informacion' });
            sigue = false;
            txtAlicuota.current.value = '0,00';
            txtTotalRete.current.value = '0,00';
            txtAlicuota.current.focus();
        } else if (parseFloat(sincomatototalret) <= 0) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto Retenido de debe ser Mayor a 0,00', icono: 'informacion' });
            sigue = false;
            txtAlicuota.current.value = '0,00';
            txtTotalRete.current.value = '0,00';
            txtAlicuota.current.focus();
        } else if (parseFloat(txtTotalRete.current.value.trim().replace(/\./g, "").replace(',', '.')) > parseFloat(txtMontoCompro.current.value.trim().replace(/\./g, "").replace(',', '.')) - sumaRete) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La suma de las retenciones no puede\nser mayor al total de la factura', icono: 'informacion' });
            sigue = false;
            txtBaseImpo.current.focus();
        }


        if (sigue) {

            seleccionarDatosRetencion();

        }

    };

    const seleccionarDatosRetencion = () => {
        var data = [];
        let iddeta = props.operacion === 1 ? '0' : props.retencionsel.iddetalle;

        data.push({
            iddetalle: iddeta,
            idtiporetencion: txtIdRetencion.current.value,
            descripcion: txtDescriret.current.value,
            baseimpo: parseFloat(txtBaseImpo.current.value.replace(/\./g, '').replace(',', '.')),
            alicuota: parseFloat(txtAlicuota.current.value.replace(/\./g, '').replace(',', '.')),
            retencion_por_ciento: parseFloat(rete_porciento.toString().replace(/\./g, '').replace(',', '.')),
            sustraendo: parseFloat(sustraendo.toString().replace(/\./g, '').replace(',', '.')),
            totalrete: parseFloat(txtTotalRete.current.value.replace(/\./g, '').replace(',', '.')),
            fecha: txtFechaRet.current.value,
        });
        setDatos(data);
        let msg = ''
        if (props.operacion === 1) {
            msg = 'registro creado correctamente.';
        } else if (props.operacion === 2) {
            msg = 'registro modificado correctamente.';
        } else if (props.operacion === 3) {
            msg = 'registro eliminado correctamente.';
        }
        setMensaje({ mostrar: true, titulo: 'Exito.', texto: msg, icono: 'exito' });

    };

    const handleInputMontoChange = (event) => {
        //setActiveIndex(1);
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which === 13 || typeof event.which === "undefined") {
            /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace('.', '').replace(',', '.')) === 0.00) {
                event.target.value = "0,00";
            } */
            event.target.value = formatoMonto(event.target.value);
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === "0" && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            if (event.target.name === 'alicuota' || event.target.name === 'totalrete' || event.target.name === 'baseimpo') {
                calcular();
            }
            if (event.which === 13) {
                if (event.target.name === 'baseimpo') {
                    txtAlicuota.current.focus();
                } else if (event.target.name === 'alicuota') {
                    btnAcepta.current.focus()
                } else if (event.target.name === 'totalrete') {
                    btnAcepta.current.focus()
                }
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false; //alert(e.which);
    };

    const handleInputChange = (event) => {
        //setActiveIndex(1);
        if (event.which === 13 || typeof event.which === "undefined") {
            //calcular();
            if (tipoUnidad === 2) {
                seleccionarValorUnidad();
            }
            if (event.which === 13 && event.target.value !== '') {
                if (event.target.name === 'fecharete') {
                    if (tipoUnidad === 2) {
                        txtAlicuota.current.focus();
                    } else if (tipoUnidad === 3) {
                        txtTotalRete.current.focus();
                    } else if (tipoUnidad === 0 || tipoUnidad === 1 || tipoUnidad === 4) {
                        txtAlicuota.current.focus();
                    }
                }
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false; //alert(e.which);
    };

    const onChange = (e) => {

        if (e.target.name === 'idtiporet') {
            txtDescriret.current.value = '';
            txtAlicuota.current.value = '';
            txtTotalRete.current.value = '';
            txtFechaRet.current.value = '';
            setHabiAlicuo(true);
            setHabiFecha(true);
            setTipoRetencion(0);
            setTipoUnidad(0);
        }

    };

    const handleDobleClick = (e) => {
        setHabiBase(false);
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                setSumaRete(parseFloat(props.retenido));
                if (props.operacion === 1) {
                    txtIdRetencion.current.value = '2';
                    txtFechaRet.current.value = moment.utc(fechaSistema).format('YYYY-MM-DD');
                    txtBaseImpo.current.value = formatMoneda(props.totalbaseimpo.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtMontoCompro.current.value = formatMoneda(props.totalfactura.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    seleccionarRetencion('2');
                } else {
                    txtIdRetencion.current.value = props.retencionsel.idtiporetencion;
                    txtBaseImpo.current.value = formatMoneda(props.retencionsel.baseimpo.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtMontoCompro.current.value = formatMoneda(props.totalfactura.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtFechaRet.current.value = moment.utc(props.retencionsel.fecha).format('YYYY-MM-DD');
                    setRete_Porciento(props.retencionsel.retencion_por_ciento);
                    setSustraendo(props.retencionsel.sustraendo);
                    /*txtDescriret.current.value = props.retencionsel.descripcion;
                    txtFechaRet.current.value = moment.utc(props.retencionsel).format('YYYY-MM-DD');
                    txtBaseImpo.current.value = formatMoneda(props.facturasel.baseimponible.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtPorceIva.current.value = formatMoneda(props.facturasel.porceiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    let moniva = parseFloat(props.facturasel.total) - parseFloat(props.facturasel.baseimponible) - parseFloat(props.facturasel.exento);
                    moniva = Math.round(parseFloat(moniva) * Math.pow(10, 4)) / Math.pow(10, 4);
                    txtMontoIva.current.value = formatMoneda(moniva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtMontoCompro.current.value = formatMoneda(props.facturasel.total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtAlicuota.current.value = formatMoneda(props.retencionsel.alicuota.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtTotalRete.current.value = formatMoneda(props.retencionsel.totalrete.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    setHabiFecha(false);*/
                    seleccionarRetencion(props.retencionsel.idtiporetencion);
                }

            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>Retención</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
                <CatalogoTipoRetencion
                    show={mostrar4}
                    onHideCancelar={handleCancelaras}
                    onHideAceptarRetenciones={handleAceptaRetenciones}
                />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className='col-md-12 row mx-auto'>
                    <div className='input-group input-group-sm col-md-3 mb-2 mx-auto'>

                        <label className="input-group-text" id="inputGroup-sizing-sm">Código:</label>
                        <input type="text" name='idtiporet' disabled={true} ref={txtIdRetencion} onChange={onChange} onKeyUp={handleRetenciones} onBlur={handleRetenciones} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />

                    </div>
                    <div className='col-md-4'></div>
                    <div className=' input-group input-group-sm col-md-5 mb-2 mx-auto'>

                        <label className="input-group-text" id="inputGroup-sizing-sm">Fecha de Retención:</label>
                        <input type="date" name='fecharete' disabled={habiFecha} ref={txtFechaRet} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" onKeyUp={handleInputChange} onBlur={handleInputChange} />

                    </div>
                    <div className=' input-group input-group-sm col-md-12 mb-2 mx-auto'>

                        <label className="input-group-text" id="inputGroup-sizing-sm">Descripción:</label>
                        <textarea style={{ height: 40 }} type="textarea" disabled={true} ref={txtDescriret} name='codigo' className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />

                    </div>
                    <div className=' input-group input-group-sm col-md-4 mb-2 mx-auto' style={{ visibility: visibleDat }}>

                        <label className="input-group-text" id="inputGroup-sizing-sm">Base Imponible:</label>
                        <input type="text" autocomplete="off" disabled={habiBase} ref={txtBaseImpo} name='baseimpo' className="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />

                    </div>
                    <div className=' input-group input-group-sm col-md-4 mb-2 mx-auto' style={{ visibility: visibleDat }}>

                        <label className="input-group-text" id="inputGroup-sizing-sm">Total Compromiso:</label>
                        <input type="text" disabled={true} ref={txtMontoCompro} name='codigo' className="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />

                    </div>
                    <div className=' input-group input-group-sm col-md-4 mb-2 mx-auto' style={{ visibility: visibleDat }}>

                        <label className="input-group-text" id="inputGroup-sizing-sm">{lblAlicuota}</label>
                        <input type="text" autocomplete="off" disabled={habiAlicuo} ref={txtAlicuota} name='alicuota' className="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />

                    </div>

                    <div className=' input-group input-group-sm col-md-4 mb-2 mx-auto' style={{ visibility: visibleDat }}>
                    </div>
                    <div className=' input-group input-group-sm col-md-4 mb-2 mx-auto' style={{ visibility: visibleDat }}>
                    </div>
                    <div className=' input-group input-group-sm col-md-4 mb-2 mx-auto'>

                        <label className="input-group-text" id="inputGroup-sizing-sm">{lblTotRete}</label>
                        <input type="text" disabled={habiRete} ref={txtTotalRete} name='totalrete' className="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />

                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} onClick={onChangeValidar} disabled={activo} style={{ margin: '1px' }} className="fw-bold btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Aceptar</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="fw-bold btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />

        </Modal>

    );
}